import axios from 'axios';
import React, { useState } from 'react';
import { Container, Row, Col, Card, Button, Form, Badge, InputGroup } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Loader from "../../Loader.jsx";

const Trackorder = () => {
  const [loader, setLoader] = useState(false);
  const [order, setOrder] = useState(null);
  const {
    handleSubmit,
    reset,
    formState: { errors },
    control,
    register
  } = useForm({ defaultValues: { trackId: null } });
  const token = useSelector((state) => state.token);

  const handleTrackOrder = (data) => {
    setLoader(true);
    axios({
      method: "GET",
      url: `${process.env.REACT_APP_BASE_URL}/order/track/${data.trackId}`,
      headers: {
        "Authorization": `Bearer ${token}`
      }
    }).then(res => {
      setOrder(res.data.order);
      setLoader(false);
    }).catch(err => {
      setLoader(false);
      if (err?.response?.data?.errors) {
        toast(err.response.data.errors[0].msg, {
          theme: "light",
          position: "top-right",
          type: "error"
        });
      } else {
        toast(err?.response?.data?.message || err.message || "Failed to track order", {
          theme: "light",
          position: "top-right",
          type: "error"
        });
      }
    });
  }

  const handleStatus = (status) => {
    if (status === "Completed") {
      return (<Badge bg="success">{status}</Badge>);
    } else if (status === "Rejected") {
      return (<Badge bg="danger">{status}</Badge>);
    } else {
      return (<Badge bg="secondary">{status}</Badge>);
    }
  }

  return (
    <section className="user_main">
      <Container>
        <Row className='justify-content-center'>
          <Col xl={8} md={12}>
            <Card>
              <Card.Header as="h5">
                <div className="d-flex align-items-center justify-content-between gap-3">
                  <div className="head_title">
                    <h3 className="mb-0">Tracking My Order</h3>
                  </div>
                </div>
              </Card.Header>
              <Card.Body>
                <Row className='justify-content-center'>
                  <Col md={12}>
                    <Form onSubmit={handleSubmit(handleTrackOrder)}>
                      <InputGroup className="mb-3">
                        <Form.Control
                          type="text"
                          placeholder="Please enter your tracking ID"
                          {...register("trackId", {
                            required: { message: "Track id is require", value: "true" },
                            min: { message: "Track id not valid", value: 10000 },
                            valueAsNumber: true,
                            validate: (value) => !isNaN(value) || "Track id not valid"
                          })} />
                        <Button type='submit' className='button yellow'>Tracking Now</Button>
                      </InputGroup>
                      {errors.trackId ? <p className='errMsg'>{errors.trackId.message}</p> : null}
                    </Form>
                  </Col>
                  {order ?
                    <Col md={12} className='mt-5'>
                      <div className="trackingbox">
                        <table>
                          <tbody>
                            <tr>
                              <td width="50%"><strong>Tracking ID</strong></td>
                              <td width="50%"><p>{order?.orderId ? order.orderId : '-'}</p></td>
                            </tr>
                            <tr>
                              <td><strong>Recipient amount</strong></td>
                              <td><p>{order?.quotation?.recipientAmount ? parseFloat(order.quotation.recipientAmount) > 0.01 ? parseFloat(order.quotation.recipientAmount).toLocaleString(undefined, { maximumFractionDigits:2, minimumFractionDigits:2 }) : parseFloat(order.quotation.recipientAmount) : '-'}</p></td>
                            </tr>
                            <tr>
                              <td><strong>Recipient name</strong></td>
                              <td><p>{order?.receiverName ? order?.receiverName : '-'}</p></td>
                            </tr>
                            <tr>
                              <td><strong>Recipient Currency</strong></td>
                              <td><p>{order?.quotation?.recipientCurrency ? order.quotation.recipientCurrency.toUpperCase() : '-'}</p></td>
                            </tr>
                            <tr>
                              <td><strong>Your Currency</strong></td>
                              <td><p>{order?.quotation?.currency ? order.quotation.currency.toUpperCase() : '-'}</p></td>
                            </tr>
                            <tr>
                              <td><strong>Rate</strong></td>
                              <td><p>{order?.quotation?.recipientCurrency === "ngn" ? order?.quotation?.displayRate ? parseFloat(order.quotation.displayRate) > 0.01 ? parseFloat(order.quotation.displayRate).toLocaleString(undefined, { maximumFractionDigits:2, minimumFractionDigits:2 }) : parseFloat(order.quotation.displayRate) : '-' : order?.quotation?.rate ? parseFloat(order.quotation.rate) > 0.01 ? parseFloat(order.quotation.rate).toLocaleString(undefined, { maximumFractionDigits:2, minimumFractionDigits:2 }) : parseFloat(order.quotation.rate) : '-'}</p></td>
                            </tr>
                            <tr>
                              <td><strong>Status</strong></td>
                              <td>
                                <p>
                                  {handleStatus(order?.status)}
                                </p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </Col>
                    : null}
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <Loader show={loader}/>
    </section>
  )
}

export default Trackorder